//Form demandez un devis
if ($(".form-demandez-devis")[0]) {
    $(function () {
        $('[data-toggle="tooltip"]').tooltip({ html: !0 });
    }),
        $(".form-demandez-devis .ft").each(function (e) {
            $(this)
                .nextUntil(".ft")
                .addBack()
                .wrapAll('<div class="inter section-' + $(this).closest(".ft").next().attr("class").split(" ").pop().toLowerCase() + '" />');
        }),
        $(".form-demandez-devis").show(),
        $(".section-prestation").addClass("essentiel"),
        $(".section-acceptcgu").addClass("essentiel"),
        $(".submit").appendTo("form");
    var ResetForm = function () {
        var e, i, c, r, o, a, y;
        $("#demsoc").val() && (e = $("#demsoc").val()),
            (i = $("#nom").val()),
            (a = $("#prenom").val()),
            (y = $("#postalcode").val()),
            (c = $("#tel").val()),
            (r = $("#mail").val()),
            (o = $("#expliquez-nous-votre-besoin").val()),
            $(".form-demandez-devis form")[0].reset(),
            void 0 !== e && $("#demsoc").val(e),
            $("#nom").val(i),
            $("#prenom").val(a),
            $("#postalcode").val(y),
            $("#tel").val(c),
            $("#mail").val(r),
            $("#expliquez-nous-votre-besoin").val(o);
            $(".test").hide();
    };
    $(".prestation input").click(function () {
        $(".selecttheme").hide();
    }),
        $("#prestationdepotmarque").click(function () {
            ResetForm(),
                $(".form-demandez-devis form div").removeClass("flexbox"),
                $(this).prop("checked", !0),
                $(".form-left .inter").hide(),
                $(".section-depotmarque").show(),
                $(".section-depotmarque").parent().show(),
                $("select#nombreclasse").prepend("<option value='adeterminer' selected='selected'>A déterminer</option>");
        }),
        $(".depotmarque input").change(function () {
            $("#ue").is(":checked") || $("#oapi").is(":checked") || $("#ompi").is(":checked") || $("#aripo").is(":checked") || $("#usa").is(":checked") || $("#organismenational").is(":checked")
                ? $(".ompimarque").css("display", "flex")
                : $(".ompimarque").css("display", "none"),
                $("#organismenational").is(":checked") ? $(".precisezpays").css("display", "flex") : $(".precisezpays").css("display", "none");
        }),
        $("select#marqueenfrance").change(function () {
            $(".colors").hide(), $("#" + $(this).val()).show();
        }),
        $("#organismenational").click(function () {
            $(".precisezpays").toggleClass("flexbox");
        }),

        $("#redaccontrat").click(function () {
            ResetForm(), 
            $("form div").removeClass("flexbox"), 
            $(this).prop("checked", !0), 
            $(".form-left .inter").hide(), 
            $(".section-redaccontrat").show(),
            $(".section-redaccontrat").parent().show();
        }),
        $("#contratautre").click(function () {
            $(".preciseztype").toggleClass("flexbox");
        }),

        $("#redaccg").click(function () {
            ResetForm(), 
            $("form div").removeClass("flexbox"), 
            $(this).prop("checked", !0), 
            $(".form-left .inter").hide(), 
            $(".section-redaccg").show(),
            $(".section-redaccg").parent().show();
        }),
        $("#redacautre").click(function () {
            $(".precisezcg").toggleClass("flexbox");
        }),

        $("#conformitergpd").click(function () {
            ResetForm(), 
            $("form div").removeClass("flexbox"), 
            $(this).prop("checked", !0), 
            $(".form-left .inter").hide(), 
            $(".section-confrgpd").show(),
            $(".section-confrgpd").parent().show();
        }),
        $("#crautre").click(function () {
            $(".autrergpd").toggleClass("flexbox");
        }),

        $("#creationsociete").click(function () {
            ResetForm(), 
            $("form div").removeClass("flexbox"), 
            $(this).prop("checked", !0), 
            $(".form-left .inter").hide(), 
            $(".section-creasociete").show(),
            $(".section-creasociete").parent().show();
        });
    var click1 = 0,
        click2 = 0;
    $("#csassistance").on("click", function () {
        0 == click1
            ? ($(".precisezcreasoc").css("display", "flex"), (click1 = 1))
            : 1 == click1 && 0 == click2
            ? ($(".precisezcreasoc").css("display", "none"), (click1 = 0))
            : 1 == click1 && 1 == click2
            ? ($(".precisezcreasoc").css("display", "flex"), (click1 = 0))
            : ((click1 = 0), $(".precisezcreasoc").css("display", "none"));
    }),
        $("#csredaction").click(function () {
            0 == click2
                ? ($(".precisezcreasoc").css("display", "flex"), (click2 = 1))
                : 1 == click2 && 0 == click1
                ? ($(".precisezcreasoc").css("display", "none"), (click2 = 0))
                : 1 == click2 && 1 == click1
                ? ($(".precisezcreasoc").css("display", "flex"), (click2 = 0))
                : ((click2 = 0), $(".precisezcreasoc").css("display", "none"));
        }),
        $("#societeautre").click(function () {
            $(".societeautre").toggleClass("flexbox");
        }),

        $("#relecturedoc").click(function () {
            ResetForm(), 
            $("form div").removeClass("flexbox"), 
            $(this).prop("checked", !0), 
            $(".form-left .inter").hide(), 
            $(".section-relecdoc").show(),
            $(".section-reledoc").parent().show();
        }),

        $("#redacreglement").click(function () {
            ResetForm(), 
            $("form div").removeClass("flexbox"), 
            $(this).prop("checked", !0), 
            $(".form-left .inter").hide();
            /*$(".section-redacregle").show(),
            $(".section-redacregle").parent().show();*/
        }),
        $("#redacreglejeu").click(function () {
            $(".obligachat").toggleClass("flexbox");
        }),
        $("#redacregleautre").click(function () {
            $(".precisezjeu").toggleClass("flexbox");
        }),

        $("#consuljuridique").click(function () {
            ResetForm(), 
            $("form div").removeClass("flexbox"), 
            $(this).prop("checked", !0), 
            $(".form-left .inter").hide(), 
            $(".section-consuljuridique").show(),
            $(".section-consuljuridique").parent().show();
        }),

        /*$("#autreprestation").click(function () {
            ResetForm(), 
            $("form div").removeClass("flexbox"), 
            $(this).prop("checked", !0), 
            $(".form-left .inter").hide(), 
            $(".section-autre").show(),
            $(".section-autre").parent().show();
        }),*/
        $(".choosedepot").click(function () {
            var e = $(this).attr("data-prestation"),
                i = $(this).attr("data-pays");
            "marque" == e && "Union Européenne" !== i
                ? (ResetForm(), $("#prestationdepotmarque").click(), $("#organismenational").click(), $("#organismepays").val(i))
                : "marque" == e && "Union Européenne" == i && (ResetForm(), $("#prestationdepotmarque").click(), $("#ue").click());
        }),
        $(".demanderdevis").click(function () {
            var e = $(this).attr("data-prestation");
            "marque" == e
                ? (ResetForm(), $("#prestationdepotmarque").click())
                : "contrat" == e
                ? (ResetForm(), $("#redaccontrat").click())
                : "ecommerce" == e
                ? (ResetForm(), $("#redaccg").click())
                : "donneespersonnelles" == e
                ? (ResetForm(), $("#conformitergpd").click())
                : "societe" == e && (ResetForm(), $("#creationsociete").click());
        });
}
var validator = $("#FormDevis").validate({
    errorElement: "span",
    errorClass: "error",
    rules: {
        nom: "required",
        prenom: 'required',
        telephone: "required",
        email: "required",
        expbesoin: "required",
        acceptcgu: "required",
        type: "required",
        postalcode: "required",
        precisezpays: { required: "#organismenational:checked" },
        preciseztype: { required: "#contratautre:checked" },
        precisezcg: { required: "#redacautre:checked" },
        autrergpd: { required: "#crautre:checked" },
        csformesoc: { required: "#csassistance:checked, #csredaction:checked" },
        societeautre: { required: "#societeautre:checked" },
        //autrerr: { required: "#redacregleautre:checked" },
        //autrepresta: { required: "#autreprestation:checked" },
        "sous_type[]": { required: !0, minlength: 1 },
    },
    messages: {
        nom: "Veuillez saisir votre nom de famille.",
        prenom: "Veuillez saisir votre prénom.",
        telephone: "Veuillez saisir un numéro de téléphone.",
        email: "Veuillez saisir un email.",
        expbesoin: "Veuillez expliquer votre besoin.",
        acceptcgu: "Veuillez accepter la politique de confidentialité.",
        type: "Veuillez choisir une prestation.",
        precisezpays: "Veuillez préciser le pays de dépôt.",
        preciseztype: "Veuillez préciser votre besoin.",
        precisezcg: "Veuillez préciser votre besoin.",
        autrergpd: "Veuillez préciser votre besoin.",
        csformesoc: "Veuillez préciser la forme de la société.",
        societeautre: "Veuillez préciser votre besoin.",
        postalcode: "Veuillez renseigner votre code postal.",
        //autrerr: "Veuillez préciser votre besoin.",
        //autrepresta: "Veuillez indiquer le nom de la prestation demandée.",
        "sous_type[]": "Merci de choisir au minimum une prestation.",
    },
    errorPlacement: function (e, i) {
        i.is(":radio") ? e.appendTo(i.parents("form .inter")) : i.is(":checkbox") ? e.appendTo(i.closest("form .inter")) : e.insertAfter(i);
    },
});
if (
    ($(".form-demandez-devis").on("submit", function (e) {
        e.preventDefault(), gtag_report_conversion();
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({'event': 'conversionFormDevis'});  
    }),
    $("#tel")[0])
) {
    var inputEl = document.getElementById("tel"),
        goodKey = "0123456789+ ",
        checkInputTel = function (e) {
            var i = "number" == typeof e.which ? e.which : e.keyCode,
                c = this.selectionStart,
                r = this.selectionEnd,
                o = this.value.split("").filter(filterInput);
            this.value = o.join("");
            var t = filterInput(String.fromCharCode(i)) || 0 == i || 8 == i ? 0 : 1;
            this.setSelectionRange(c - t, r - t);
        },
        filterInput = function (e) {
            return goodKey.indexOf(e) > -1;
        };
    inputEl.addEventListener("input", checkInputTel);
}
